<template>
<div class="row align-items-center pt-2 pb-2 border-top" >
<div class="col-sm-6">
        <span class>{{ labelText }}</span>
      </div>
      <div class="col-sm-6">
      <kendo-switch :value="value" v-model="value" :name="fieldName"  @change="changeVal"
               ></kendo-switch>
   
      </div>
      </div>
  <!-- <div class="col-4 mb-3"> -->
    <!-- <label>{{ labelText }}</label>

     <kendo-switch :value="value" v-model="value" :name="fieldName"  @change="changeVal"
               ></kendo-switch>
  </div> -->
</template>
<script>
export default {
  name: "Toggle",
  props: ["placeholder", "labelText", "fieldName", "value"],
  methods:{
    changeVal(e){
      // console.log(e,this.value)
      this.$emit('input',e.checked)
    }
  }
};
</script>